// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__LaHLT","colBig":"styles_colBig__3_3Ot","colSmall":"styles_colSmall__Lpqwz"};